(() => {
  const items = Array.from(document.querySelectorAll('.pl-collection-guides__item'));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const animate = (panel, from, to, onFinish) => {
    if (panel.animation) panel.animation.cancel();
    panel.style.overflow = 'hidden';
    const animation = panel.animate({ height: [from + 'px', to + 'px'] }, { duration: 300, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' });
    panel.animation = animation;
    animation.onfinish = animation.oncancel = () => {
      if (panel.animation !== animation) return;
      panel.animation = null;
      panel.style.overflow = '';
      if (onFinish) onFinish();
    };
  };

  const open = (item) => {
    const panel = item.querySelector('.pl-collection-guides__panel');
    const from = item.open ? panel.offsetHeight : 0;
    item.open = true;
    item.classList.add('is-open');
    if (!reduceMotion.matches) animate(panel, from, panel.scrollHeight);
  };

  const close = (item) => {
    const panel = item.querySelector('.pl-collection-guides__panel');
    item.classList.remove('is-open');
    if (reduceMotion.matches) {
      item.open = false;
    } else {
      animate(panel, panel.offsetHeight, 0, () => { item.open = false; });
    }
  };

  items.forEach((item) => {
    item.querySelector('summary').addEventListener('click', (event) => {
      event.preventDefault();

      // At most one guide is open; the open one can be closed again.
      if (item.classList.contains('is-open')) {
        close(item);
        return;
      }

      items.forEach((other) => { if (other !== item && other.open) close(other); });
      open(item);
    });
  });
})();
